document.addEventListener('DOMContentLoaded', function () {
  const map = initMap();
  loadGeoJSON(map);
  const markers = createMarkers(map, window.locations);
  createLocationList(window.locations, markers, map);

  setTimeout(() => {
    map.invalidateSize();
  }, 100);
});

// Initializing the map
function initMap() {
  const map = L.map('map', {
    zoomControl: false,
    dragging: false,
    scrollWheelZoom: false,
    doubleClickZoom: false,
    touchZoom: false,
    boxZoom: false,
    keyboard: false,
  }).setView([47.75, -13.6], 2);

  L.control.zoom({ position: 'bottomright' }).addTo(map);

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '',
    opacity: 0,
  }).addTo(map);

  return map;
}

// Loading and displaying GeoJSON
function loadGeoJSON(map) {
  fetch('https://raw.githubusercontent.com/johan/world.geo.json/master/countries.geo.json')
    .then((res) => res.json())
    .then((data) => {
      L.geoJSON(data, {
        style: () => ({
          fillColor: 'transparent',
          color: '#6482a0',
          weight: 1,
          fillOpacity: 1,
        }),
      }).addTo(map);
    });
}

function createMarkers(map, locations) {
  const markers = [];

  if (!map.getPane('markersPane')) {
    map.createPane('markersPane');
    map.getPane('markersPane').style.zIndex = 650;
  }

  // SVG for states
  const inactiveSVG = `
    <svg width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.1483 3.35661C20.9568 7.16529 20.9569 13.3407 17.1483 17.1493C16.6867 17.611 16.1392 18.1102 15.5628 18.6326C14.9834 19.1578 14.3719 19.7089 13.7688 20.283C12.5581 21.4355 11.4153 22.6509 10.6808 23.8751L10.2437 24.6037L9.81899 23.8682C9.08587 22.5984 7.94622 21.3848 6.73714 20.2464C6.13475 19.6792 5.52437 19.1385 4.94451 18.6209C4.36808 18.1063 3.81869 17.6124 3.35559 17.1493C-0.453016 13.3407 -0.452903 7.16529 3.35559 3.35661C7.16425 -0.452049 13.3397 -0.452049 17.1483 3.35661Z" fill="#75A3ED" stroke="#34475B"/>
    </svg>

  `;
  const activeSVG = `
    <svg width="93" height="95" viewBox="0 0 93 95" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M69.8721 68.7487C68.2903 70.3323 66.4073 72.0536 64.3958 73.8789C62.3818 75.7063 60.2368 77.64 58.121 79.6564C53.8855 83.6926 49.7933 88.0356 47.136 92.4695L46.7868 93.0527L46.4472 92.464C43.791 87.8581 39.7005 83.5162 35.4663 79.5251C33.351 77.5312 31.2065 75.6314 29.1922 73.8312C27.1807 72.0334 25.2968 70.3334 23.7139 68.7487L23.0313 68.0654H70.5546L69.8721 68.7487Z" fill="white" stroke="#34475B" stroke-width="0.8"/>
      <path d="M46.8086 13.3687C55.3562 13.3728 63.5531 16.7753 69.5957 22.8276C75.6381 28.8799 79.0322 37.087 79.0322 45.644C79.0322 52.0281 77.1408 58.2687 73.5977 63.5767C70.0545 68.8845 65.0187 73.021 59.127 75.4634C53.2352 77.9057 46.7522 78.544 40.498 77.2974C34.2442 76.0507 28.5001 72.9756 23.9922 68.4604C19.4842 63.9452 16.4141 58.1929 15.1719 51.9312C13.9297 45.6694 14.5712 39.179 17.0137 33.2817C19.4561 27.3847 23.5901 22.3448 28.8936 18.8003C34.1971 15.2558 40.4319 13.3657 46.8086 13.3687ZM38.3027 27.4907C37.0254 27.4907 35.7962 27.9802 34.8682 28.8589C33.9403 29.7376 33.3836 30.9387 33.3125 32.2153V58.5181C33.2818 58.9589 33.3055 59.4042 33.3926 59.8423C33.5854 60.8128 34.0619 61.7041 34.7607 62.4038C35.4597 63.1036 36.3508 63.5809 37.3203 63.7739C37.6515 63.8398 37.9869 63.8675 38.3213 63.8657C38.3092 63.8658 38.2972 63.8677 38.2852 63.8677H55.7783C56.457 63.9056 57.1361 63.8037 57.7744 63.5698C58.4128 63.3359 58.9973 62.974 59.4912 62.5063C59.9849 62.0388 60.3787 61.475 60.6475 60.8501C60.9162 60.2252 61.0547 59.5519 61.0547 58.8716C61.0547 58.191 60.9163 57.5172 60.6475 56.8921C60.3786 56.2671 59.9851 55.7034 59.4912 55.2358C58.9973 54.7682 58.4128 54.4063 57.7744 54.1724C57.1362 53.9385 56.4569 53.8376 55.7783 53.8755V53.8599H43.293V32.2153C43.2218 30.9386 42.6652 29.7376 41.7373 28.8589C40.8093 27.9802 39.5801 27.4907 38.3027 27.4907ZM38.5361 63.8599C38.5338 63.86 38.5316 63.8607 38.5293 63.8608C38.5316 63.8607 38.5338 63.86 38.5361 63.8599ZM43.2832 53.8628H38.2949C38.1836 53.8628 38.0725 53.8671 37.9619 53.8745C38.0724 53.8668 38.1834 53.8622 38.2949 53.8618H43.2832V53.8628ZM55.791 27.2124C53.0307 27.2124 50.793 29.4529 50.793 32.2163C50.7931 34.9796 53.0308 37.2202 55.791 37.2202C58.5513 37.2202 60.7889 34.9797 60.7891 32.2163C60.7891 29.4529 58.5513 27.2124 55.791 27.2124Z" fill="white"/>
      <path opacity="0.5" d="M38.2911 53.8615H43.2891V32.2152C43.218 30.9383 42.6612 29.7373 41.7331 28.8586C40.8051 27.9799 39.5762 27.4902 38.2989 27.4902C37.0215 27.4902 35.7926 27.9799 34.8646 28.8586C33.9365 29.7373 33.3798 30.9383 33.3086 32.2152V58.8651C33.3086 57.5408 33.833 56.2704 34.767 55.3325C35.7009 54.3946 36.9682 53.8656 38.2911 53.8615V53.8615Z" fill="white"/>
      <path opacity="0.5" d="M55.7782 53.8601H43.2832V58.8638C43.2832 59.5209 43.1539 60.1715 42.9027 60.7786C42.6515 61.3857 42.2834 61.9373 41.8193 62.4019C41.3552 62.8665 40.8042 63.2351 40.1978 63.4866C39.5914 63.738 38.9415 63.8674 38.2852 63.8674H55.7782C56.457 63.9054 57.1363 63.8042 57.7747 63.5703C58.413 63.3364 58.997 62.9745 59.4909 62.5069C59.9848 62.0393 60.3782 61.4757 60.6471 60.8506C60.916 60.2255 61.0547 59.5521 61.0547 58.8715C61.0547 58.191 60.916 57.5176 60.6471 56.8925C60.3782 56.2674 59.9848 55.7038 59.4909 55.2362C58.997 54.7686 58.413 54.4067 57.7747 54.1728C57.1363 53.9388 56.457 53.8377 55.7782 53.8756V53.8601Z" fill="white"/>
      <path d="M46.8086 14.9683C54.9312 14.9723 62.7202 18.2056 68.4629 23.9575C74.2058 29.7097 77.4326 37.5104 77.4326 45.644C77.4326 51.7118 75.6349 57.6433 72.2676 62.688C68.9001 67.7328 64.1137 71.6648 58.5146 73.9858C52.9157 76.3068 46.7547 76.9135 40.8115 75.729C34.8681 74.5443 29.4085 71.6209 25.124 67.3296C20.8397 63.0382 17.9219 57.5713 16.7412 51.6196C15.5605 45.6679 16.1698 39.4992 18.4912 33.894C20.8127 28.2889 24.7428 23.499 29.7832 20.1304C34.8235 16.7619 40.7487 14.9653 46.8086 14.9683Z" stroke="white" stroke-width="3.2"/>
    </svg>
  `;

  const inactiveIcon = L.divIcon({
    className: 'custom-marker',
    html: inactiveSVG,
    iconSize: [24, 24],
    iconAnchor: [12, 24],
  });

  const activeIcon = L.divIcon({
    className: 'custom-marker',
    html: activeSVG,
    iconSize: [92, 92],
    iconAnchor: [46, 92],
  });

  const now = new Date();

  locations.forEach((location) => {
    const end = new Date(location.endDate);
    if (end < now) {
      //li.classList.add('expired');
      return; // if expired, do not add to the list
    }

    const marker = L.marker(location.coords, {
      icon: inactiveIcon,
      pane: 'markersPane',
    }).addTo(map);

    marker.on('click', () => {
      // Removing active class from all list items
      document.querySelectorAll('.research-map-location-item.active').forEach((el) => el.classList.remove('active'));

      const listItem = document.querySelector(`.research-map-location-item[data-id="${location.id}"]`);

      if (listItem) {
        listItem.classList.add('active');
        listItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      handleMarkerClick(marker, markers, location, map);
    });

    // Saving references to icons
    marker._inactiveIcon = inactiveIcon;
    marker._activeIcon = activeIcon;
    marker._locationId = location.id;

    markers.push(marker);
  });

  return markers;
}

function handleMarkerClick(marker, markers, location, map) {
  // Setting all markers to inactive
  markers.forEach((m) => {
    m.setIcon(m._inactiveIcon);

    const el = m.getElement();
    if (el) el.style.pointerEvents = 'auto';
  });

  // Making the selected marker active
  marker.setIcon(marker._activeIcon);

  setTimeout(() => {
    const el = marker.getElement();
    if (el) el.style.pointerEvents = 'none';
  }, 0);

  if (window.innerWidth <= 768) {
    map.flyTo(location.coords, 4, { animate: true, duration: 0.5 });
  } else {
    marker.openPopup();
  }
}

function formatDateRange(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const options = { month: 'short' };
  const startMonth = start.toLocaleDateString(window.shopLocale, options);
  const endMonth = end.toLocaleDateString(window.shopLocale, options);

  const startYear = start.getFullYear().toString().slice(-2); // last two digits of year
  const endYear = end.getFullYear().toString().slice(-2);

  if (startMonth === endMonth && startYear === endYear) {
    // if month and year are the same, display once
    return `${startMonth} ${start.getDate()}-${end.getDate()} '${startYear}`;
  } else if (startYear === endYear) {
    // if only the year is the same
    return `${startMonth} ${start.getDate()} - ${endMonth} ${end.getDate()} '${startYear}`;
  } else {
    // if years are different
    return `${startMonth} ${start.getDate()} '${startYear} - ${endMonth} ${end.getDate()} '${endYear}`;
  }
}

function sortLocationsByStartDate(locations) {
  locations.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
}

function createLocationList(locations, markers, map) {
  const now = new Date();

  sortLocationsByStartDate(locations);
  locations.forEach((location, i) => {
    const marker = markers.find((m) => m._locationId === location.id);
    const li = document.createElement('li');
    li.classList.add('research-map-location-item');
    li.setAttribute('data-id', location.id);

    const end = new Date(location.endDate);

    if (end < now) {
      //li.classList.add('expired');
      return; // if expired, do not add to the list
    }

    const title = document.createElement('p');
    title.classList.add('research-map-location-item-title');
    title.classList.add('p3');
    title.textContent = location.name;
    li.appendChild(title);

    // Container for date and location
    const infoDiv = document.createElement('div');
    infoDiv.classList.add('research-map-loc-date-container');

    const locationElem = document.createElement('p');
    locationElem.classList.add('research-map-location-item-city');
    locationElem.textContent = location.location;
    infoDiv.appendChild(locationElem);

    const whiteImg = document.createElement('img');
    whiteImg.src = 'https://cdn.shopify.com/s/files/1/0669/6219/4700/files/location.svg?v=1758875219';
    whiteImg.alt = `${location.name} logo`;
    whiteImg.classList.add('research-map-location-item-location-icon');
    whiteImg.classList.add('light');
    whiteImg.width = 20;
    whiteImg.height = 20;
    infoDiv.appendChild(whiteImg);

    const darkImg = document.createElement('img');
    darkImg.src = 'https://cdn.shopify.com/s/files/1/0669/6219/4700/files/location_c652a9ef-d680-4c01-8ab8-28c5fa5972bb.svg?v=1764753249';
    darkImg.alt = `${location.name} logo`;
    darkImg.classList.add('research-map-location-item-location-icon');
    darkImg.classList.add('dark');
    darkImg.width = 20;
    darkImg.height = 20;
    infoDiv.appendChild(darkImg);

    const date = document.createElement('p');
    date.classList.add('research-map-location-item-date');
    date.textContent = formatDateRange(location.startDate, location.endDate);
    infoDiv.appendChild(date);

    li.appendChild(infoDiv);

    li.onclick = () => {
      document.querySelectorAll('.research-map-location-item.active').forEach((el) => el.classList.remove('active'));

      li.classList.add('active');

      handleMarkerClick(marker, markers, location, map);
    };

    document.getElementById('locations').appendChild(li);
  });
}
